export enum KnmErknmFormFieldsNamesTemplatesEnum {
  MANUAL_ADDRESS = 'manualAddress',
  REGION = 'region',
  FIO_SINGER = 'fioSigner',
  TITLE_SINGER = 'titleSigner',
  ACTS = 'acts',
  ACT = 'acts[i]',
  ACT_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_TYPE = 'acts[i].familiarizationNotifications[i].knmNoticeType',
  ACT_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTICE_DATE = 'acts[i].familiarizationNotifications[i].noticeDate',
  ACT_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTE = 'acts[i].familiarizationNotifications[i].note',
  ACT_ORGANIZATION_REMARKS_TEXT = 'acts[i].remarks[i].text',
  ACT_ORGANIZATION_REMARKS_TEXT_REACT_QUILL_EDITOR = 'acts[i].remarks[i].textReactQuillEditor',
  ACT_ORGANIZATION_REMARKS_SIGNER_FULLNAME = 'acts[i].remarks[i].signerFullName',
  ACT_ORGANIZATION_REMARKS_SIGNER_POSITION = 'acts[i].remarks[i].signerPosition',
  ACT_REMARKS_SIGNER_POSITION = 'acts[i].remarks[i].date',
  ACT_ORGANIZATION_REMARKS_DATE = 'organization.act.remarks[i].date',
  ACT_CREATION_ACT_DATE_TIME = 'acts[i].creationActDateTime',
  ACT_HOLDING_DATE_TIME = 'acts[i].holdingDateTime',
  ACT_ORGANIZATION_TEMPLATE = 'acts[i].organizationTemplate',
  ACT_ORGANIZATION_SUBJECT_TYPE = 'acts[i].organization.subjectType',
  ACT_OGRN = 'acts[i].organization.ogrn',
  ACT_ORGANIZATION_NAME = 'acts[i].organization.organizationName',
  ACT_LOCATION_ADDRESS = 'acts[i].organization.locationAddress',
  ACT_INN = 'acts[i].organization.inn',
  ACT_ORGANIZATION_RAFPNZA = 'acts[i].organization.rafpNza',
  ACT_ORGANIZATION_KPP = 'acts[i].organization.kpp',
  ACT_ORGANIZATION_COUNTRY = 'acts[i].organization.country',
  ACT_ORGANIZATION_DOCUMENT = 'acts[i].organization.document',
  ACT_ORGANIZATION_SNILS = 'acts[i].organization.snils',
  ACT_ORGANIZATION_IS_PRESENT_IN_IT_REGISTRY = 'acts[i].organization.isPresentInItRegistry',
  ACT_ORGANIZATION_IS_SONKO_REGISTRY = 'acts[i].organization.isSonko',
  ACT_ORGANIZATION_IS_MSP_REGISTRY = 'acts[i].organization.mspCode',
  ACT_ORGANIZATION_IS_NKO_REGISTRY = 'acts[i].organization.isNko',
  ACT_KNO_INSPECTORS = 'acts[i].knoInspectors',
  ACT_KNO_INSPECTOR = 'acts[i].knoInspectors[i]',
  ACT_KNO_INSPECTOR_KNO_INSPECTOR = 'acts[i].knoInspectors[i].knoInspector',
  ACT_KNO_INSPECTOR_FULL_NAME = 'acts[i].knoInspectors[i].fullName',
  ACT_KNO_INSPECTOR_POSITION = 'acts[i].knoInspectors[i].position',
  ACT_FIO_READER = 'acts[i].fioReader',
  ACT_REFUSER_FIO = 'acts[i].refuserFio',
  ACT_REFUSER_TITLE = 'acts[i].refuserTitle',
  ACT_TITLE_READER = 'acts[i].titleReader',
  ACT_DURATION_DAYS = 'acts[i].durationDays',
  ACT_DURATION_HOURS = 'acts[i].durationHours',
  ACT_ACQUAINTANCE_TYPE = 'acts[i].acquaintanceType',
  ACT_ACQUAINTANCE_LACK_TYPE = 'acts[i].acquaintanceLackType',
  ACT_TYPE_ACT = 'acts[i].typeAct',
  ACT_CANCELED_REASON = 'acts[i].canceledReason',
  ACT_CANCELED_REASON_DESCRIPTION = 'acts[i].canceledReasonDescription',
  ACT_CANCELED_REASON_DESCRIPTION_REACT_QUILL_EDITOR = 'acts[i].canceledReasonDescriptionReactQuillEditor',
  ACT_DOCUMENTS_ATTACHMENTS = 'acts[i].document.attachments',

  ACT_IS_VIOLATED_REQUIREMENTS_MANDATORY = 'acts[i].isViolatedMandatoryRequirements',
  ACT_VIOLATED_REQUIREMENTS = 'acts[i].violatedMandatoryRequirements',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].mandatory',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_CATEGORY = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].category',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATIONS = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].title',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE_REACT_QUILL_EDITOR = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].descriptionReactQuillEditor',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED_ON_PLACE = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].isFixedOnPlace',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].isFixed',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_VIOLATION_REPEAT_CORRECTED = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].repeatCorrected',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPES = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].type',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPE = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].type[i].value',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_METHOD = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].method',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].attachments',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES_VIDEO_LINK = 'acts[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].attachments[i].link.value',

  ACT_INVOLVED_EXPERTS = 'acts[i].involvedExperts[i].expert',

  ACT_INVOLVED_WITNESSES_VALUE = 'acts[i].involvedWitnesses[i].fullName',

  ACT_EVENTS = 'acts[i].events',
  ACT_EVENT = 'acts[i].events[i]',
  ACT_EVENT_PROTOCOL_ATTACHMENTS = 'acts[i].events[i].protocol.attachments',
  ACT_EVENT_INSPECTORS = 'acts[i].events[i].inspectors',
  ACT_EVENT_INSPECTOR_FULL_NAME = 'acts[i].events[i].inspectors[i].fullName',
  ACT_EVENT_START_DATE = 'acts[i].events[i].startDate',
  ACT_EVENT_STOP_DATE = 'acts[i].events[i].stopDate',
  ACT_EVENT_PROTOCOL_FILE_ATTACHMENTS = 'acts[i].events[i].protocol.file.attachments',
  ACT_EVENT_LINK_VKS = 'acts[i].events[i].linkVks',
  ACT_EVENT_LINK_VIDEO = 'acts[i].events[i].linkVideo',
  ACT_EVENT_TYPE = 'acts[i].events[i].type',
  ACT_EVENT_UAV_TECHNOLOGIES = 'acts[i].events[i].uavTechnologies',
  ACT_EVENT_UAV_TECHNOLOGIES_TYPE = 'acts[i].events[i].uavTechnologies[i].type',
  ACT_EVENT_UAV_TECHNOLOGIES_NAME = 'acts[i].events[i].uavTechnologies[i].name',
  ACT_FIO_AND_POSITION_SIGNER = 'acts[i].fioAndPositionSinger',
  ACT_FIO_SIGNER = 'acts[i].fioSigner',
  ACT_TITLE_SIGNER = 'acts[i].titleSigner',
  ACT_NUMBER_ACT = 'acts[i].numberAct',
  DOC_TARGET = 'docTarget',
  DOC_TARGET_ITEM = 'docTarget[i]',
  DOC_TARGET_ITEM_DOC_TARGET_TYPE = 'docTarget[i].docTargetType',
  DOC_TARGET_ITEM_ERVK_CONTROL_KIND_DOC_TARGET = 'docTarget[i].ervkControlKindDocTarget',
  APPROVE_DOCS = 'approveDocs',
  APPROVE_DOC = 'approveDocs[i]',
  APPROVE_DOC_APPROVE_DOC = 'approveDocs[i].approveDoc',
  LINKS = 'links',
  APPROVE_NOTE = 'approveNote',
  APPROVE_NOTE_APPEAL = 'approveNoteAppeal',
  APPROVE_REQUIRED = 'approveRequired',
  APPROVE_REMARKS_REMARK = 'approveRemarks[i].remark',
  DATA_CONTENT = 'dataContent',
  APPROVED = 'approved',
  APPROVED_NUMBER_DECISION = 'approveNumberDecision',
  APPROVED_DATE_DECISION = 'approveDateDecision',
  APPROVED_FIO_SINGER = 'approveFioSigner',
  APPROVED_TITLE_SINGER = 'approveTitleSigner',
  APPROVED_FILE = 'approveFile',
  REJECTED_REASON_TYPE = 'rejectReasonType',
  COLLABORATING_ORGANIZATIONS = 'collaboratingOrganizationsErknm',
  COLLABORATING_ORGANIZATIONS_ITEM = 'collaboratingOrganizationsErknm[i]',
  COLLABORATING_ORGANIZATIONS_ITEM_ORGANIZATION = 'collaboratingOrganizationsErknm[i].organization',
  COLLABORATING_ORGANIZATIONS_ITEM_TITLE = 'collaboratingOrganizationsErknm[i].title',
  APPROVED_ON_PAPER_DOCUMENTS_ATTACHMENTS = 'approvedOnPaperDocuments.attachments',
  DOCUMENT = 'documents[i]',
  DOCUMENT_TYPE = 'documents[i].type',
  DOCUMENT_ATTACHMENTS = 'documents[i].attachments',
  DURATION_DAYS = 'durationDays',
  DURATION_HOURS = 'durationHours',
  DIRECT_DURATION_DAYS = 'directDurationDays',
  EVENTS = 'eventsErknm',
  EVENT = 'eventsErknm[i]',
  EVENT_INTERACTION_CATEGORY = 'eventsErknm[i].interactionCategory',
  EVENT_START_DATE = 'eventsErknm[i].startDate',
  EVENT_STOP_DATE = 'eventsErknm[i].stopDate',
  EVENT_TYPE = 'eventsErknm[i].type',
  EVENT_SUBMITTED_DOCUMENTS = 'eventsErknm[i].submittedDocuments',
  EVENT_SUBMITTED_DOCUMENTS_TITLE_ID = 'eventsErknm[i].submittedDocuments[i].documentTitle',
  EVENT_SUBMITTED_DOCUMENTS_REQUEST_DATETIME_ID = 'eventsErknm[i].submittedDocuments[i].requestDateTime',
  EVENT_SUBMITTED_DOCUMENTS_DEADLINE_ID = 'eventsErknm[i].submittedDocuments[i].submissionDeadline',
  EVENT_SUBMITTED_DOCUMENTS_SUBMISSION_DATETIME_ID = 'eventsErknm[i].submittedDocuments[i].submissionDateTime',
  EVENT_SUBMITTED_DOCUMENTS_FILE_ID = 'eventsErknm[i].submittedDocuments[i].files',
  EXPERTS = 'experts',
  EXPERT = 'experts[i]',
  EXPERT_TITLE = 'experts[i].title',
  EXPERT_TYPE = 'experts[i].type',
  INN = 'inn',
  INSPECTORS = 'inspectorsErknm',
  INSPECTOR = 'inspectorsErknm[i]',
  INSPECTOR_FULL_NAME = 'inspectorsErknm[i].fullName',
  INSPECTOR_POSITION = 'inspectorsErknm[i].position',
  KIND_CONTROL = 'kindControl',
  KIND_KNM = 'kindKnm',
  KNO_ORGANIZATION = 'knoOrganizationErknm',
  PLACE_DECISION = 'placeDecision',
  RESCHEDULING_NEW_START_DATE_ID = 'rescheduling[i].newStartDate',
  RESCHEDULING_NEW_END_DATE_ID = 'rescheduling[i].newEndDate',
  RESCHEDULING_NEW_DURATION_DAYS_ID = 'rescheduling[i].newDirectDurationDays',
  RESCHEDULING_NEW_DURATION_HOURS_ID = 'rescheduling[i].newDurationHours',
  ABROGATION_REASON_ID = 'abrogation.reasonId',
  ABROGATION_LINK = 'abrogation.link',
  TITLE_SIGNER = 'titleSigner',
  OGRN = 'ogrn',
  OBJECTS = 'objectsErknm',
  OBJECT = 'objectsErknm[i]',
  OBJECT_OBJECT_NAME = 'objectsErknm[i].name',
  OBJECT_ADDRESS = 'objectsErknm[i].address',
  OBJECT_OBJECT_TYPE = 'objectsErknm[i].objectType',
  OBJECT_OBJECT_KIND = 'objectsErknm[i].objectKind',
  OBJECT_OBJECT_SUB_KIND = 'objectsErknm[i].objectSubKind',
  OBJECT_RISK_CATEGORY = 'objectsErknm[i].riskCategory',
  OBJECT_DANGER_CLASS = 'objectsErknm[i].dangerClass',
  OBJECT_REGION = 'objectsErknm[i].region',
  OBJECT_MANUAL_ADDRESS = 'objectsErknm[i].manualAddress',
  OLD_KNM_NUMBER = 'oldKnmNumber',
  OLD_PLAN_NUMBER = 'oldPlanNumber',
  ORGANIZATIONS = 'organizations',
  ORGANIZATION = 'organizations[i]',
  ORGANIZATION_SUBJECT_TYPE = 'organizations[i].subjectType',
  ORGANIZATION_IS_PRESENT_IN_IT_REGISTRY = 'organizations[i].isPresentInItRegistry',
  ORGANIZATION_IS_SONKO_REGISTRY = 'organizations[i].isSonko',
  ORGANIZATION_IS_MSP_REGISTRY = 'organizations[i].mspCode',
  ORGANIZATION_IS_NKO_REGISTRY = 'organizations[i].isNko',
  ORGANIZATION_OGRN = 'organizations[i].ogrn',
  ORGANIZATION_ORGANIZATION_NAME = 'organizations[i].organizationName',
  ORGANIZATION_INN = 'organizations[i].inn',
  ORGANIZATION_OKVEDS = 'organizations[i].okveds',
  ORGANIZATION_OKVED = 'organizations[i].okveds[i]',
  ORGANIZATION_OKVED_OKVED = 'organizations[i].okveds[i].okved',
  ORGANIZATION_RAFP_NZA = 'organizations[i].rafpNza',
  ORGANIZATION_KPP = 'organizations[i].kpp',
  ORGANIZATION_SNILS = 'organizations[i].snils',
  ORGANIZATION_COUNTRY = 'organizations[i].country',
  ORGANIZATIONS_ADDRESS = 'organizations[i].locationAddress',
  ORGANIZATIONS_FIAS_REGION = 'organizations[i].locationfiasRegion',
  ORGANIZATION_DOCUMENT = 'organizations[i].document',
  ORGANIZATION_DOCUMENTS = 'organizationDocuments',
  ORGANIZATION_DOCUMENT_ITEM = 'organizationDocuments[i]',
  ORGANIZATION_DOCUMENT_VALUE = 'organizationDocuments[i].value',
  PLACES = 'places',
  CHECKLISTS = 'checklistsErknm',
  CHECKLIST_CHECK = 'checklistsErknm[i].checkList',
  CHECKLIST_ERVK_CHECK = 'checklistsErknm[i].ervkCheckList',
  CHECKLIST_NEW_TITLE = 'checklistsErknm[i].newTitle',
  CHECKLIST_QUESTIONS = 'checklistsErknm[i].questions',
  CHECKLIST_QUESTION_TITLE = 'checklistsErknm[i].questions[i].title',
  PLACE = 'places[i]',
  PLACE_VALUE = 'places[i].value',
  PLACE_REGION = 'places[i].region',
  PLACE_MANUAL_ADDRESS = 'places[i].manualAddress',
  PLACE_FIAS_REGION = 'places[i].fiasRegion',
  PLAN_ID = 'planId',
  PLAN_SELECT_OPTION = 'planSelectOption',
  PROSECUTOR_ORGANIZATION = 'prosecutorOrganizationErknm',
  REASON_DOCUMENTS = 'reasonDocuments',
  REASON_DOCUMENT = 'reasonDocuments[i]',
  REASON_DOCUMENT_TYPE = 'reasonDocuments[i].type',
  REASON_DOCUMENT_ATTACHMENTS = 'reasonDocuments[i].attachments',
  REASON_DOCUMENT_VIOLATION_EVIDENCES = 'reasonDocuments[i].violationEvidences',
  REASON_DOCUMENT_VIOLATION_EVIDENCES_DATE = 'reasonDocuments[i].violationEvidences[i].date',
  REASON_DOCUMENT_VIOLATION_EVIDENCES_LINK = 'reasonDocuments[i].violationEvidences[i].link',
  REASON_DOCUMENT_VIOLATION_EVIDENCES_DESCRIPTION = 'reasonDocuments[i].violationEvidences[i].description',
  REASONS = 'reasonsErknm',
  REASON = 'reasonsErknm[i]',
  REASON_LINK_VALIDATION = 'reasonsErknm[i].linkValidation',
  REASON_TYPE = 'reasonsErknm[i].type',
  REASON_TEXT = 'reasonsErknm[i].text',
  REASON_DATE = 'reasonsErknm[i].date',
  REASON_DATE_REQUIREMENT = 'reasonsErknm[i].dateRequirement',
  REASON_RISK_INDICATORS_VALUE = 'reasonsErknm[i].riskIndicators',
  REASON_RISK_INDICATOR_VALUE = 'reasonsErknm[i].riskIndicators[i]',
  REASON_RISK_INDICATOR = 'reasonsErknm[i].riskIndicators[i].riskIndicator',
  REASON_RISK_INDICATOR_AUTO = 'reasonsErknm[i].riskIndicators[i].indicatorRiskAuto',
  REASON_RISK_INDICATOR_FILE = 'reasonsErknm[i].riskIndicators[i].indicatorRiskAttachment',
  REASON_ASSIGNMENT_NUMBER = 'reasonsErknm[i].assignmentNumber',
  REASON_ASSIGNMENT_DATE = 'reasonsErknm[i].assignmentDate',
  REASON_ASSIGNMENT_FULLNAME = 'reasonsErknm[i].fullName',
  REASON_REQUIREMENT_DETAILS = 'reasonsErknm[i].requirementDetails',
  REASON_LAST_CONDUCTED_KNM_DATE = 'reasonsErknm[i].lastConductedKnmDate',
  REASON_REQUIREMENT_ORDER = 'reasonsErknm[i].order',
  REASON_LINKS = 'reasonsErknm[i].links',
  REASON_PASSPORT_LINKS = 'reasonsErknm[i].passportLinks',
  REASON_VIOLATION_EVIDENCES = 'reasonsErknm[i].violationEvidences',
  REASON_VIOLATION_EVIDENCES_LINK = 'reasonsErknm[i].violationEvidences[i].link',
  REASON_PROGRAM_NUMBER = 'reasonsErknm[i].programNumber',
  REASON_PROGRAM_ATTACHMENT = 'reasonsErknm[i].programAttachment',
  INTERACTION_CATEGORY = 'interactionCategory',
  VIDEO_CALL_INFO = 'videoCallInfo',
  VIDEO_CALL_INFO_ITEM = 'videoCallInfo[i]',
  VIDEO_CALL_INFO_ITEM_LINK = 'videoCallInfo[i].link',
  VIDEO_CALL_INFO_ITEM_DATE_TIME = 'videoCallInfo[i].dateTime',
  REMOTE_NOTE = 'remoteNote',
  REQUIREMENTS = 'requirementsErknm',
  REQUIREMENT = 'requirementsErknm[i]',
  REQUIREMENT_MANUAL_TITLE = 'requirementsErknm[i].manualTitle',
  REQUIREMENT_MANUAL_NAME_NPA = 'requirementsErknm[i].manualNameNpa',
  REQUIREMENT_MANUAL_DATE_NPA = 'requirementsErknm[i].manualDateNpa',
  RESULT_DECISIONS = 'resultDecisions',
  RESULT_DECISION = 'resultDecisions[i]',
  RESULT_DECISION_NUMBER_DECISION = 'resultDecisions[i].numberDecision',
  RESULT_DECISION_DATE_DECISION = 'resultDecisions[i].dateDecision',
  RESULT_DECISION_IS_PROSECUTION = 'resultDecisions[i].isProsecution',
  RESULT_DECISION_ORGANIZATION_TEMPLATE = 'resultDecisions[i].organizationTemplate',
  RESULT_DECISION_SUBJECT_TYPE_FOUNDER = 'resultDecisions[i].subjectTypeFounder',
  RESULT_DECISION_SUBJECT_TYPE = 'resultDecisions[i].organization.subjectType',
  RESULT_DECISION_OGRN = 'resultDecisions[i].organization.ogrn',
  RESULT_DECISION_ORGANIZATION_NAME = 'resultDecisions[i].organization.organizationName',
  RESULT_DECISION_ADDRESS = 'resultDecisions[i].organization.locationAddress',
  RESULT_DECISION_INN = 'resultDecisions[i].organization.inn',
  RESULT_DECISION_COUNTRY = 'resultDecisions[i].organization.country',
  RESULT_DECISION_RAFP_NZA = 'resultDecisions[i].organization.rafpNza',
  RESULT_DECISION_KPP = 'resultDecisions[i].organization.kpp',
  RESULT_DECISION_INSPECTORS = 'resultDecisions[i].inspectors',
  RESULT_DECISION_INSPECTOR = 'resultDecisions[i].inspectors[i]',
  RESULT_DECISION_INSPECTOR_FULL_NAME = 'resultDecisions[i].inspectors[i].fullName',
  RESULT_DECISION_INSPECTOR_POSITION = 'resultDecisions[i].inspectors[i].position',
  RESULT_DECISION_KIND_DECISION = 'resultDecisions[i].kindDecision',
  RESULT_DECISION_ACT = 'resultDecisions[i].act',
  RESULT_DECISION_NOTE_LAWSUITS = 'resultDecisions[i].noteLawsuits',
  RESULT_DECISION_DOCUMENT_ATTACHMENTS = 'resultDecisions[i].document.attachments',
  RESULT_DECISION_PROTOCOL_ATTACHMENTS = 'resultDecisions[i].protocol.attachments',
  RESULT_DECISION_NOTE_LAWSUIT = 'resultDecisions[i].noteLawsuits[i]',
  RESULT_DECISION_PUNISHMENT_NATURE = 'resultDecisions[i].punishmentNature',
  RESULT_DECISION_FIO_SIGNER = 'resultDecisions[i].fioSigner',
  RESULT_DECISION_POSITION_SIGNER = 'resultDecisions[i].titleSigner',
  RESULT_DECISION_NOTE_LAWSUIT_VALUE = 'resultDecisions[i].noteLawsuits[i].value',
  RESULT_DECISION_NOTE_LAWSUIT_VALUE_REACT_QUILL_EDITOR = 'resultDecisions[i].noteLawsuits[i].valueReactQuillEditor',
  RESULT_DECISION_RESPONSIBLE_ENTITIES = 'resultDecisions[i].responsibleEntities',
  RESULT_DECISION_RESPONSIBLE_ENTITY = 'resultDecisions[i].responsibleEntities[i]',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION = 'resultDecisions[i].responsibleEntities[i].organization',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE = 'resultDecisions[i].responsibleEntities[i].organization.value',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_TYPE = 'resultDecisions[i].responsibleEntities[i].organization.value.type',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_SUBJECT_TYPE = 'resultDecisions[i].responsibleEntities[i].organization.value.subjectType',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_INN = 'resultDecisions[i].responsibleEntities[i].organization.value.inn',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_OGRN = 'resultDecisions[i].responsibleEntities[i].organization.value.ogrn',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_ORGANIZATION_NAME = 'resultDecisions[i].responsibleEntities[i].organization.value.organizationName',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_FULL_NAME = 'resultDecisions[i].responsibleEntities[i].organization.value.fullName',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_SNILS = 'resultDecisions[i].responsibleEntities[i].organization.value.snils',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_POSITION = 'resultDecisions[i].responsibleEntities[i].organization.value.position',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_COUNTRY = 'resultDecisions[i].responsibleEntities[i].organization.value.country',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_KPP = 'resultDecisions[i].responsibleEntities[i].organization.value.kpp',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_RAFP = 'resultDecisions[i].responsibleEntities[i].organization.value.rafpNza',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_DOCUMENT = 'resultDecisions[i].responsibleEntities[i].organization.value.document',
  RESULT_DECISION_RESPONSIBLE_ENTITY_RESPONSIBILITY_TYPE = 'resultDecisions[i].responsibleEntities[i].responsibilityType',
  RESULT_DECISION_RESPONSIBLE_ENTITY_PUNISHMENT_AMOUNT = 'resultDecisions[i].responsibleEntities[i].punishmentAmount',
  RESULT_DECISION_RESPONSIBLE_ENTITY_PUNISHMENT_AMOUNT_MEASURE = 'resultDecisions[i].responsibleEntities[i].punishmentAmountMeasure',
  RESULT_DECISION_RESPONSIBLE_ENTITY_PUNISHMENT_TERM = 'resultDecisions[i].responsibleEntities[i].punishmentTerm',
  RESULT_DECISION_RESPONSIBLE_ENTITY_TYPE = 'resultDecisions[i].responsibleEntities[i].type',
  RESULT_DECISION_RESPONSIBLE_ENTITY_FULL_NAME = 'resultDecisions[i].responsibleEntities[i].fullName',
  RESULT_DECISION_RESPONSIBLE_ENTITY_SNILS = 'resultDecisions[i].responsibleEntities[i].snils',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_STRUCTURES_NPA = 'resultDecisions[i].responsibleEntities[i].organization.value.structuresNPA',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_STRUCTURES_NPA_ITEM = 'resultDecisions[i].responsibleEntities[i].organization.value.structuresNPA[i]',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_STRUCTURES_NPA_ITEM_VALUE = 'resultDecisions[i].responsibleEntities[i].organization.value.structuresNPA[i].value',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ERVK_CONTROL_KIND_NPA_UNIT = 'resultDecisions[i].responsibleEntities[i].ervkControlKindNpaUnit',
  RESULT_DECISION_RESPONSIBLE_ENTITY_STRUCTURES_NPA = 'resultDecisions[i].responsibleEntities[i].structuresNPA',
  RESULT_DECISION_RESPONSIBLE_ENTITY_STRUCTURES_NPA_ITEM = 'resultDecisions[i].responsibleEntities[i].structuresNPA[i]',
  RESULT_DECISION_RESPONSIBLE_ENTITY_STRUCTURES_NPA_ITEM_VALUE = 'resultDecisions[i].responsibleEntities[i].structuresNPA[i].value',
  RESULT_DECISION_INJUNCTION_NOTE = 'resultDecisions[i].injunction.note',
  RESULT_DECISION_INJUNCTION_NOTE_REACT_QUILL_EDITOR = 'resultDecisions[i].injunction.noteReactQuillEditor',

  RESULT_DECISION_RESPONSIBLE_ENTITY_INN_OLD = 'resultDecisions[i].responsibleEntities[i].inn',
  RESULT_DECISION_RESPONSIBLE_ENTITY_OGRN_OLD = 'resultDecisions[i].responsibleEntities[i].ogrn',
  RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_NAME_OLD = 'resultDecisions[i].responsibleEntities[i].organizationName',
  RESULT_DECISION_RESPONSIBLE_ENTITY_POSITION_OLD = 'resultDecisions[i].responsibleEntities[i].position',
  RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_TYPE = 'resultDecisions[i].familiarizationNotifications[i].knmNoticeType',
  RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTICE_DATE = 'resultDecisions[i].familiarizationNotifications[i].noticeDate',
  RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTE = 'resultDecisions[i].familiarizationNotifications[i].note',

  RESULT_DECISION_VIOLATED_MANDATORY = 'resultDecisions[i].violatedMandatoryRequirements',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATIONS = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations',
  RESULT_DECISION_VIOLATED_MANDATORY_UNIQUE = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].mandatory',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIXED_ON_PLACE = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].isFixedOnPlace',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIXED = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].isFixed',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_PLAN_EXPLANATIONS = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanExplanations',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_PLAN_EXPLANATIONS_REQUIRED = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanExplanationsRequired',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_DATES = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanDates',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_DATES_REQUIRED = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanDatesRequired',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_DATE = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanDates[i].value',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_METHODS = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanMethods',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_METHODS_REQUIRED = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanMethodsRequired',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_FACT_METHOD = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixFactMethod',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_METHOD = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanMethods[i].value',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_EXPLANATION = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanExplanations[i].value',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_EXPLANATION_REACT_QUILL_EDITOR = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanExplanations[i].valueReactQuillEditor',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPES = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].type',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPE = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].type[i].value',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPE_EXPLANATION = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].explanationMaterial',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPE_EXPLANATION_REACT_QUILL_EDITOR = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].explanationMaterialReactQuillEditor',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_METHOD = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].method',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_FILES = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].attachments',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_FILES_VIDEO_LINK = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].attachments[i].link.value',
  RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_GRADE = 'resultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].grade',

  RESULT_DECISION_FOUNDER_SUBJECT_TYPE_KNM = 'resultDecisions[i].founder.subjectTypeKnm',
  RESULT_DECISION_FOUNDER_INN = 'resultDecisions[i].founder.inn',
  RESULT_DECISION_FOUNDER_OGRN = 'resultDecisions[i].founder.ogrn',
  RESULT_DECISION_FOUNDER_ORGANIZATION_NAME = 'resultDecisions[i].founder.organizationName',
  RESULT_DECISION_FOUNDER_OKVEDS = 'resultDecisions[i].founder.okveds',
  RESULT_DECISION_FOUNDER_OKVED = 'resultDecisions[i].founder.okveds[i]',
  RESULT_DECISION_FOUNDER_OKVED_OKVED = 'resultDecisions[i].founder.okveds[i].okved',
  RESULT_DECISION_FOUNDER_SNILS = 'resultDecisions[i].founder.snils',
  RESULT_DECISION_FOUNDER_DOCUMENT = 'resultDecisions[i].founder.document',
  RESULT_DECISION_FOUNDER_COUNTRY = 'resultDecisions[i].founder.country',
  RESULT_DECISION_FOUNDER_RAFP_NZA = 'resultDecisions[i].founder.rafpNza',
  RESULT_DECISION_FOUNDER_KPP = 'resultDecisions[i].founder.kpp',

  JUDGMENTS = 'judgments',
  JUDGMENT = 'judgments[i]',
  JUDGMENT_DATE = 'judgments[i].dateJudgment',
  JUDGMENT_NUMBER = 'judgments[i].numberJudgment',
  JUDGMENT_KIND = 'judgments[i].kindJudgment',
  JUDGMENT_ATTACHMENT = 'judgments[i].attachment',
  JUDGMENT_REGION = 'judgments[i].rfRegionCode',
  JUDGMENT_COURT = 'judgments[i].court',
  JUDGMENT_COURT_LEVEL = 'judgments[i].courtLevelCode',
  JUDGMENT_ACTION = 'judgments[i].judgmentAction',
  JUDGMENT_SUBJECTS_DATA = 'judgments[i].judgmentSubjectData',
  JUDGMENT_SUBJECT_DATA = 'judgments[i].judgmentSubjectData[i]',
  JUDGMENT_SUBJECT_DATA_GUID = 'judgments[i].judgmentSubjectData[i].organizationGuid',
  JUDGMENT_SUBJECT_DATA_AGAINST_ORG = 'judgments[i].judgmentSubjectData[i].isJudgmentAgainstOrganizations',
  JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOrganizations',
  JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_PROSECUTION_TYPE = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOrganizations.prosecutionType',
  JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_PUNISHMENT_TYPE = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOrganizations.punishmentType',
  JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_AMOUNT_OF_PUNISHMENT = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOrganizations.amountOfPunishment',
  JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_PUNISHMENT_INDEX = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOrganizations.punishmentIndex',
  JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_NOTE_LAWSUITS = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOrganizations.punishmentNoteLawsuits',
  JUDGMENT_SUBJECT_DATA_AGAINST_PERSON = 'judgments[i].judgmentSubjectData[i].isJudgmentAgainstOfficialPerson',
  JUDGMENT_SUBJECT_DATA_AGAINST_PERSONS = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOfficialPerson',
  JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOfficialPerson[i]',
  JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_FIO = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOfficialPerson[i].officialPersonFio',
  JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_JOB = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOfficialPerson[i].officialPersonJobTitle',
  JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_PROSECUTION_TYPE = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOfficialPerson[i].prosecutionType',
  JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_PUNISHMENT_TYPE = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOfficialPerson[i].punishmentType',
  JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_AMOUNT_OF_PUNISHMENT = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOfficialPerson[i].amountOfPunishment',
  JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_PUNISHMENT_INDEX = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOfficialPerson[i].punishmentIndex',
  JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_NOTE_LAWSUITS = 'judgments[i].judgmentSubjectData[i].judgmentAgainstOfficialPerson[i].punishmentNoteLawsuits',
  JUDGMENT_SUBJECT_DATA_CANCELLATION_ACTS_AND_DECISIONS = 'judgments[i].judgmentSubjectData[i].cancellationActsAndDecisions',
  JUDGMENT_SUBJECT_DATA_CANCELLATION_ACT_OR_DECISION = 'judgments[i].judgmentSubjectData[i].cancellationActsAndDecisions[i]',
  JUDGMENT_SUBJECT_DATA_CANCELLATION_ACT_OR_DECISION_CANCELLATION_INFO = 'judgments[i].judgmentSubjectData[i].cancellationActsAndDecisions[i].cancellationInformation',
  JUDGMENT_SUBJECT_DATA_CANCELLATION_ACT_OR_DECISION_EXPLANATION = 'judgments[i].judgmentSubjectData[i].cancellationActsAndDecisions[i].explanation',
  JUDGMENT_CANCELED_JUDGMENTS = 'judgments[i].canceledJudgments',
  JUDGMENT_CANCELED_JUDGMENT = 'judgments[i].canceledJudgments[i]',
  JUDGMENT_CANCELED_JUDGMENT_GUID = 'judgments[i].canceledJudgments[i].guid',
  JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_ORG_CANCELLATION_INFO = 'judgments[i].canceledJudgments[i].judgmentSubjectData[i].judgmentAgainstOrganizations.cancellationInformation',
  JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_ORG_EXPLANATION = 'judgments[i].canceledJudgments[i].judgmentSubjectData[i].judgmentAgainstOrganizations.explanation',
  JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_PERSON_INFO_CANCELLATION_INFO = 'judgments[i].canceledJudgments[i].judgmentSubjectData[i].judgmentAgainstOfficialPerson[i].cancellationInformation',
  JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_PERSON_INFO_EXPLANATION = 'judgments[i].canceledJudgments[i].judgmentSubjectData[i].judgmentAgainstOfficialPerson[i].explanation',
  JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_ACT_OR_DECISION_CANCELLATION_INFO = 'judgments[i].canceledJudgments[i].judgmentSubjectData[i].cancellationActsAndDecisions[i].newCancellationInformation',
  JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_ACT_OR_DECISION_EXPLANATION = 'judgments[i].canceledJudgments[i].judgmentSubjectData[i].cancellationActsAndDecisions[i].newExplanation',
  START_DATE = 'startDate',
  START_TIME = 'startTime',
  STOP_DATE = 'stopDate',
  STOP_TIME = 'stopTime',
  REASON_ERKNM_TEXT_REACT_QUILL_EDITOR = 'reasonsErknm[i].textReactQuillEditor',
  TYPE = 'typeErknm',
  TYPE_2 = 'typeErknm2',
  REQUIREMENTS_NPA_ERKNM_ARRAY = 'requirementsNpaErknm',
  REQUIREMENTS_NPA_ERKNM = 'requirementsNpaErknm[i].npa',
  REQUIREMENTS_NPA_ERKNM_MANDATORY = 'requirementsNpaErknm[i].mandatory',
  SUSPENSION_EVENT_ATTACHMENTS = 'suspensionEvents[i].attachments',
  SUSPENSION_EVENT_EVENT = 'suspensionEvents[i].event',
  SUSPENSION_EVENT_DECISION_DATE_TIME = 'suspensionEvents[i].decisionDateTime',
  SUSPENSION_EVENT_DECISION_NUMBER = 'suspensionEvents[i].decisionNumber',
  SUSPENSION_EVENT_DECISION_PLACE = 'suspensionEvents[i].decisionPlace',
  SUSPENSION_EVENT_REGION = 'suspensionEvents[i].region',
  SUSPENSION_EVENT_MANUAL_ADDRESS = 'suspensionEvents[i].manualAddress',
  SUSPENSION_EVENT_START_DATE = 'suspensionEvents[i].startDate',
  SUSPENSION_EVENT_STOP_DATE = 'suspensionEvents[i].stopDate',
  NOTIFICATIONS = 'subjectNotifications',
  NOTIFICATION = 'subjectNotifications[i]',
  NOTIFICATION_DATE = 'subjectNotifications[i].date',
  NOTIFICATION_TYPE = 'subjectNotifications[i].type',
  NOTIFICATION_COMMENT = 'subjectNotifications[i].comment',

  AGREEMENT_RESULT_PRESCRIPTION = 'agreements[i].prescription',
  AGREEMENT_VIOLATIONS = 'agreements[i].violations',
  AGREEMENT_VIOLATIONS_VIOLATIONS = 'agreements[i].violations[i].violatedMandatory[i].violations',
  AGREEMENT_VIOLATIONS_VIOLATION_FIX_FACT_METHOD = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixFactMethod',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPES = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].type',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].type[i].value',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE_EXPLANATION = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].explanationMaterial',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE_EXPLANATION_REACT_QUILL_EDITOR = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].explanationMaterialReactQuillEditor',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_METHOD = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].method',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_FILES = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].attachments',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_FILES_VIDEO_LINK = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].attachments[i].link.value',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_GRADE = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].grade',
  AGREEMENT_PETITION_ORGANIZATION_TYPE = 'agreements[i].petitionOrganizationType',
  AGREEMENT_PETITION_ATTACHMENT = 'agreements[i].petitionAttachment',
  AGREEMENT_PETITION_ORGANIZATION_INN = 'agreements[i].petitionOrganization.inn',
  AGREEMENT_PETITION_ORGANIZATION_OGRN = 'agreements[i].petitionOrganization.ogrn',
  AGREEMENT_PETITION_ORGANIZATION_SNILS = 'agreements[i].petitionOrganization.snils',
  AGREEMENT_PETITION_ORGANIZATION_SUBJECT_TYPE = 'agreements[i].petitionOrganization.subjectType',
  AGREEMENT_PETITION_ORGANIZATION_ORGANIZATION_NAME = 'agreements[i].petitionOrganization.organizationName',
  AGREEMENT_PETITION_ORGANIZATION_ORGANIZATION_LOCATION_ADDRESS = 'agreements[i].petitionOrganization.locationAddress',
  AGREEMENT_APPROVAL_OF_AGREEMENT = 'agreements[i].approvalOfAgreement',
  AGREEMENT_APPROVAL_OF_AGREEMENT_ATTACHMENT = 'agreements[i].approvalOfAgreementAttachment',
  AGREEMENT_ELIMINATE_VIOLATIONS_NUMBER = 'agreements[i].eliminateViolationsNumber',
  AGREEMENT_CONCLUSION_DATE = 'agreements[i].conclusionDate',
  AGREEMENT_COMPLETION_DATE = 'agreements[i].termOfExecutionAgreement',
  AGREEMENT_ELIMINATE_VIOLATIONS_ATTACHMENT = 'agreements[i].eliminateViolationsAttachment',
  AGREEMENT_APPLICATION_FOR_CONSIDERATION_ATTACHMENT = 'agreements[i].applicationForConsiderationAttachment',
  AGREEMENT_VIOLATION_CORRECTION_PROGRAM_ATTACHMENTS = 'agreements[i].violationCorrectionProgramAttachments',
  AGREEMENT_APPROVE_INFO_PROSECUTOR_ORGANIZATION = 'agreements[i].prosecutorOrganization',
  AGREEMENT_FIO_SIGNER = 'agreements[i].fioSigner',
  AGREEMENT_TITLE_SIGNER = 'agreements[i].titleSigner',
  AGREEMENT_APPROVE_INFO_NOTE = 'agreements[i].approveInfo.note',
  AGREEMENT_APPROVE_INFO_APPROVED = 'agreements[i].approveInfo.approved',
  AGREEMENT_APPROVE_INFO_NUMBER_DECISION = 'agreements[i].approveInfo.numberDecision',
  AGREEMENT_APPROVE_INFO_DATE_DECISION = 'agreements[i].approveInfo.dateDecision',
  AGREEMENT_APPROVE_INFO_WHO_MADE_DECISION = 'agreements[i].approveInfo.whoMadeDecision',
  AGREEMENT_APPROVE_INFO_TITLE_SIGNER = 'agreements[i].approveInfo.titleSigner',
  AGREEMENT_APPROVE_INFO_ATTACHMENT = 'agreements[i].approveInfo.attachment',
  AGREEMENT_TERMINATE_TERMINATION_REASONS = 'agreements[i].terminate.terminationReasons',
  AGREEMENT_TERMINATE_TERMINATION_REASONS_ITEM = 'agreements[i].terminate.terminationReasons[i]',
  AGREEMENT_TERMINATE_DECISION_TERMINATION_ATTACHMENT = 'agreements[i].terminate.decisionTerminationAttachment',
  AGREEMENT_TERMINATE_TITLE_SIGNER = 'agreements[i].terminate.titleSigner',
  AGREEMENT_TERMINATE_TITLE_SIGNER_LABEL = 'agreements[i].terminate.titleSigner.label',
  AGREEMENT_TERMINATE_FIO_SIGNER = 'agreements[i].terminate.fioSigner',
  AGREEMENT_EXECUTION_DECISION = 'agreements[i].execution.decision',
  AGREEMENT_EXECUTION_EXECUTION_DATE = 'agreements[i].execution.executionDate',
  AGREEMENT_EXECUTION_TITLE_SIGNER = 'agreements[i].execution.titleSigner',
  AGREEMENT_EXECUTION_FIO_SIGNER = 'agreements[i].execution.fioSigner',
  AGREEMENT_CHANGE_TYPES = 'agreements[i].changes[i].types',
  AGREEMENT_CHANGE_TYPES_ITEM = 'agreements[i].changes[i].types[i].type',
  AGREEMENT_CHANGE_REASON = 'agreements[i].changes[i].reasons',
  AGREEMENT_CHANGE_REASON_ITEM = 'agreements[i].changes[i].reasons[i]',
  AGREEMENT_CHANGE_ATTACHMENTS = 'agreements[i].changes[i].attachment',
  AGREEMENT_CHANGE_TERM_OF_EXECUTION_AGREEMENT = 'agreements[i].changes[i].termOfExecutionAgreement',
  AGREEMENT_CHANGE_UPDATED_AGREEMENT_ATTACHMENTS = 'agreements[i].changes[i].updatedAgreementAttachment',
  AGREEMENT_CHANGE_PETITION_ATTACHMENTS = 'agreements[i].changes[i].petitionAttachment',
  AGREEMENT_CHANGE_FIO_SIGNER = 'agreements[i].changes[i].fioSigner',
  AGREEMENT_CHANGE_TITLE_SIGNER = 'agreements[i].changes[i].titleSigner',
  CHANGE_PLAN_REASON_APPROVE_ERKNM = 'changePlanReason[i].approvedChangePlanErknm',
  CHANGE_PLAN_REASON_APPROVE_FIO_SIGNER = 'changePlanReason[i].approveChangePlanFioSigner',
  CHANGE_PLAN_REASON_APPROVE_DATE_DECISION = 'changePlanReason[i].approveChangePlanDateDecision',
  CHANGE_PLAN_REASON_APPROVE_TITLE_SIGNER = 'changePlanReason[i].approveChangePlanTitleSigner',
  CHANGE_PLAN_REASON_APPROVE_FILE = 'changePlanReason[i].approveChangePlanFile',
}
